export default __webpack_public_path__ + "static/media/investment.ec0bd90f.svg";